document.addEventListener('alpine:init', () => {
    Alpine.data('headerNav', () => ({
        mobileNav: false,
        open: null,
        openTimer: 0,
        closeTimer: null,
        stuck: false,
        threshold: 0,
        barHeight: 0,

        init() {
            this.$nextTick(() => {
                this.recalc();
                window.addEventListener('scroll', () => this.onScroll(), {
                    passive: true
                });
                window.addEventListener('resize', () => this.recalc());
            });
        },

        recalc() {
            const bar = this.$refs.whiteBar;
            if (!bar) return;
            const rect = bar.getBoundingClientRect();
            this.threshold = 76;
            this.barHeight = bar.offsetHeight;
            this.onScroll();
        },

        onScroll() {
            this.stuck = window.scrollY >= this.threshold;
        },

        scheduleOpenOnHover(slug) {
            if (window.innerWidth < 1024) {
                return;
            }

            this.cancelOpenOnHover();
            this.openTimer = setTimeout(() => {
                this.open = slug;
            }, 300)
        },

        cancelOpenOnHover() {
            clearTimeout(this.openTimer);
            this.openTimer = 0;
        },

        openOnClick(slug) {
            if (window.innerWidth < 1024) {
                this.open = this.open === slug ? null : slug;
            }
        },

        scheduleClose() {
            if (window.innerWidth >= 1024) {
                this.cancelClose();
                this.closeTimer = setTimeout(() => {
                    this.open = null;
                }, 300);
            }
        },

        cancelClose() {
            if (this.closeTimer) {
                clearTimeout(this.closeTimer);
                this.closeTimer = null;
            }
        },

        close() {
            this.cancelOpenOnHover();
            this.cancelClose();
            this.open = null;
        },

        /**
         * Methods sets src attribute from data-src attribute
         *
         * Used in new--header where category megamenu is rendered to prevent image from loading on page load
         * Instead image is loaded, when user hovers on category, by setting src attribute
         *
         * @param slug
         * @param imageEl
         */
        loadImageIfSlugMatches(slug, imageEl) {
            if (this.open === slug && imageEl.hasAttribute('data-src')) {
                imageEl.setAttribute('src', imageEl.dataset.src);
                imageEl.removeAttribute('data-src');
            }
        }
    }));
});

document.addEventListener('DOMContentLoaded', function () {
    const openBtn = document.getElementById('mobile-menu-switch');
    const closeBtn = document.getElementById('close-mobile-menu');
    const menu = document.querySelector('.mobile-menu');
    const view = menu ? menu.querySelector('.mobile-menu__view') : null;

    if (!openBtn || !menu) {
        console.warn('Mobile menu: Open-Button oder .mobile-menu Wrapper fehlt.');
        return;
    }

    function openMenu() {
        menu.classList.add('is-open');
        document.body.classList.add('mobile-menu-open');
    }

    function closeMenu() {
        menu.classList.remove('is-open');
        document.body.classList.remove('mobile-menu-open');
    }

    openBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openMenu();
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
            e.preventDefault();
            closeMenu();
        });
    }

    menu.addEventListener('click', function (e) {
        if (view && !view.contains(e.target)) {
            closeMenu();
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.classList.contains('is-open')) {
            closeMenu();
        }
    });
});
